import {useTheme} from '@mui/material';
import {bool} from 'prop-types';

import {REPORT_MODULES_CATEGORIES} from '../../../const';
import {useIsModuleVisibleOrEnabled} from '../../../hooks/components/report-modules/useIsModuleVisibleOrEnabled/useIsModuleVisibleOrEnabled';
import useBudget from '../../../hooks/providers/useBudget';
import useMainSidebar from '../../../hooks/providers/useMainSidebar';
import useReport from '../../../hooks/providers/useReport';
import {moduleCategoryShape} from '../../../proptypes-shapes';
import {getIconComponent} from '../../../utils';
import useReportModuleClickHandler from '../../embed/hooks/useReportModuleClickHandler/useReportModuleClickHandler';
import ModulesListPopper from '../ModulesListPopper/ModulesListPopper';
import SidebarCard from '../SidebarCard/SidebarCard';

// eslint-disable-next-line complexity
const ReportModulesCategory = ({category, isNestedInPopper}) => {
  const {selectedProject} = useReport();
  const {spreadsheetDataLoaded} = useBudget();
  const {
    modulesMenuAnchorEl,
    setModulesMenuAnchorEl,
    moduleCategoryExpanded,
    setModuleCategoryExpanded,
    moreReportsOrModulesPopperRef,
    setIsReportAndModulesMobileDrawerOpen,
    setIsMoreReportsPopperOpen,
    setIsMoreModulesPopperOpen
  } = useMainSidebar();

  const {isModuleVisible, isModuleEnabled} = useIsModuleVisibleOrEnabled();
  const theme = useTheme();

  const isExpanded = moduleCategoryExpanded === category.id;
  const isCategoryEnabled = category.modules.some(m => isModuleEnabled(m));
  const isCategoryDisabledBecauseUserIsNotOwner = category.requiresProjectOwnership && category.modules.every(m => m.requiresSirenSelected) && selectedProject && !selectedProject.is_owner;
  const isCategoryDisabledBecauseAllRequireSiren = category.modules.every(m => m.requiresSirenSelected) && !selectedProject;
  const isCategoryDisabledBecauseBudgetDataLoading = category.id === REPORT_MODULES_CATEGORIES.ACCOUNTING_BUDGET.id && !spreadsheetDataLoaded;

  const hasVisibleModules = category.modules.some(m => isModuleVisible(m));
  const handleModuleClick = useReportModuleClickHandler();

  console.log({isCategoryEnabled, id: category.id});

  const onCollapse = () => setModuleCategoryExpanded(null);
  const onExpand = () => setModuleCategoryExpanded(category.id);

  const toggleExpanded = e => {
    if (!isExpanded) {
      onExpand(category.id);
      setModulesMenuAnchorEl(e.currentTarget);
    }

    /*    if (isSmallScreen) {
          setIsMoreModulesPopperOpen(false);
        } */
  };

  const handleCategoryClick = async e => {
    const categoryOnlyHasOneVisibleModule = category.modules.filter(m => isModuleVisible(m))?.length === 1;
    // Business rule: if category contains only one visible module, we don't open the modules menu and instead directly open the module itself
    if (categoryOnlyHasOneVisibleModule) {
      const visibleModule = category.modules.find(m => isModuleVisible(m));
      await handleModuleClick(visibleModule, e);
      setIsMoreReportsPopperOpen(false);
      setIsMoreModulesPopperOpen(false);
      setModuleCategoryExpanded(null);
      setIsReportAndModulesMobileDrawerOpen(false);
    } else {
      toggleExpanded(e);
    }
  };

  if (!hasVisibleModules) return null;

  const getTooltip = () => {
    if (isCategoryEnabled) return '';
    if (isCategoryDisabledBecauseAllRequireSiren) return "Veuillez sélectionner un dossier pour activer l'outil";
    if (isCategoryDisabledBecauseBudgetDataLoading) return 'Veuillez patienter pendant le chargement des données du budget financier';
    if (isCategoryDisabledBecauseUserIsNotOwner) return 'Vous ne disposez pas des droits pour utiliser cet outil';
    if (category.id === REPORT_MODULES_CATEGORIES.ANALYSIS.id) return "Positionnez-vous sur une page avec une analyse pour activer l'outil";
    return '';
  };

  const tooltip = getTooltip();

  const IconComponent = getIconComponent(category.icon);

  return (
    <SidebarCard
      label={category.label}
      icon={<IconComponent sx={{color: isExpanded ? theme.palette.primary.main : '#6F6F6F'}} />}
      selected={isExpanded}
      tooltip={tooltip}
      disabled={!isCategoryEnabled}
      onClick={isCategoryEnabled ? handleCategoryClick : null}
    >
      {isCategoryEnabled && category.modules.length > 1 && isExpanded && (
        <ModulesListPopper
          onClose={() => {
            onCollapse();
          }}
          isNestedInPopper={isNestedInPopper}
          category={category}
          anchorEl={isNestedInPopper ? moreReportsOrModulesPopperRef?.current : modulesMenuAnchorEl}
        />
      )}
    </SidebarCard>
  );
};

ReportModulesCategory.propTypes = {
  category: moduleCategoryShape.isRequired,
  isNestedInPopper: bool.isRequired
};

export default ReportModulesCategory;
